import axios from 'axios';
import qs from 'qs';
const http = {
  get: (url, data) => {
    return new Promise((resolve, reject) => {
      http.request('get', url, data).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      })
    })
  },
  post: (url, data) => {
    return new Promise((resolve, reject) => {
      http.request('post', url, data).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      })
    })
  },
  postJson: (url, data) => {
    return new Promise((resolve, reject) => {
      http.request('post', url, data, {
        'Content-Type': 'application/json',
      }, 'json').then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      })
    });
  },
  postFile: (url, data) => {
    return new Promise((resolve, reject) => {
      http.request('post', url, data, {
        'Content-Type': 'multipart/form-data'
      }, 'postFile', '/file').then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      })
    });
  },
  wechatRequest: (url, data) => {
    return new Promise((resolve, reject) => {
      http.request('get', url, data, '', '', '/adaptor/wechat').then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      })
    });
  },
  request: (methods, url, data, headers, type, setpath) => {
    let path = '/connector/api';
    if(setpath) {
      path = setpath
    }
    let params = {
      method: methods,
      url: window.api + path + url,
      headers: {
        'Cache-Control': 'no-cache',
      },
    }
    if (type == 'postFile') {
      params.url = window.fileApi + path + url;
    }
    if(headers) {
      params.headers = {
        ...params.headers,
        ...headers,
      };
    }
    if (methods === 'get' || methods === 'delete') {
      params.params = data;
    } else if(['postFile', 'json'].includes(type)) {
      params.data = data;
    }else {
      params.data = qs.stringify(data);
    }
    return new Promise((resolve, reject) => {
      // console.log(params);
      axios(params).then(function (response) {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    })
  }
}
export {
  http
}



// WEBPACK FOOTER //
// ./src/services/http.js